exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#controls[data-v-2aefae32]{\n    position: fixed;\n    height: 50px;\n    background-color: #ebf5ef;\n    color: black;\n    width: 100%;\n}\n.toggle-pages-wrapper[data-v-2aefae32]{\n    display: flex;\n}\n", ""]);

// exports
